<template>
  <div class="page-container">
    <van-image class="active-value-bg" :src="activeValueBg" width="100%" />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="top-box">
        <div class="finish-title">本期已完成活跃值目标</div>
        <div class="active-box">上期获得活跃值2000</div>
        <van-button
          @click.stop="navigateTo('/brisk/briskUploadGroupPic')"
          class="upload-group-pic-btn"
          color="linear-gradient(179deg, #FFCED5 0%, #FF7689 100%)"
        >
          上传群截图
        </van-button>
        <div class="active-value-des-tag">活跃值说明</div>
        <van-image class="big-gold-coin" :src="BigLove" :width="transPxToRem(172)" :height="transPxToRem(172)" />
      </div>

      <div class="content-box">
        <div class="cur-active-value-box" v-if="hasLifeLev">
          <div class="cur-active-value-wrp">
            当前活跃值 <span class="cur-active-value">350</span><span class="total-active-value">/2000</span>
          </div>
          <van-button class="view-rank-btn" plain color="#FF97A5"> 查看排行 </van-button>
          <div class="cur-active-pre-bar">
            <div class="complete-par"></div>
            <div class="active-par"></div>
            <div class="reached-point point">
              <van-icon :name="SmallLoveIcon" :size="36" />
              <div>350</div>
            </div>
            <div class="finish-point point">
              <van-icon :name="HasFinishIcon" :size="26" />
              <div>2000</div>
            </div>
          </div>
        </div>
        <div class="history-box-title">历史活跃值完成统计</div>
        <van-list
          class="list-container"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          @load="getList"
        >
          <div
            class="list-item-wrp"
            v-for="item in list"
            :key="item.period_id"
            @click="navigateTo(`/brisk/briskDetails?periodId=${item.period_id}`)"
          >
            <div class="list-item-content">
              <div class="active-value-box">
                <div class="active-value">活跃值 {{ item.brisk }}</div>
                <div
                  class="view-rank"
                  @click.stop="
                    navigateTo(
                      `/brisk/briskRank?periodId=${item.period_id}&startDate=${item.start_time}&endDate=${item.end_time}`
                    )
                  "
                >
                  查看排行
                </div>
              </div>
              <div class="done-time">完成时间: {{ item.start_time }} 至 {{ item.end_time }}</div>
            </div>
            <div class="view-details">
              查看明细
              <van-icon name="arrow" />
            </div>
          </div>
        </van-list>
        <van-empty
          v-if="list.length == 0 && !loading"
          image-size="240"
          image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
          description="暂无数据"
        />
      </div>
      <van-popup v-model:show="isRulesPop" round closeable position="bottom" :style="{ minHeight: '30%' }">
        <div class="active-value-rule-box">
          <div class="active-value-rule-title">活跃值规则</div>
          <div class="active-value-get-type" v-for="item in briskRules" :key="item.name">
            <div>{{ item.name }}</div>
            <div>+{{ item.brisk }}</div>
          </div>
        </div>
      </van-popup>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, computed } from 'vue'
import { Button } from 'vant'
import activeValueBg from '@/assets/img/active_value_bg.png'
import BigLove from '@/assets/img/big_love.png'
import SmallLoveIcon from '@/assets/img/small_love_icon.png'
import HasFinishIcon from '@/assets/img/has_finish_icon.png'
import BigSixBg from '@/assets/img/big_six_bg.png'
// import notFinishIcon from '@/assets/img/not_finish_icon.png'
import { transPxToRem } from '@/utils'
import { getBriskRuleApi, userBriskPeriodListApi, groupScreenshotDetailApi, getIsHasUploadGroupApi } from '@/api/brisk'
import usePage from '@/hooks/usePage'

const { navigateTo } = usePage()
const hasLifeLev = ref(false)

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const postParams = ref({})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  finished.value = false
  list.value = []
  pageParams.page = 1
}

const getList = async () => {
  loading.value = true
  try {
    const resData = await userBriskPeriodListApi({ ...pageParams, ...postParams.value })
    list.value.push(...resData.list)
    pageParams.page++
    finished.value = list.value.length === Number(resData.count)
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    reset()
    getList()
  } finally {
    refreshing.value = false
  }
}

const isRulesPop = ref(false)
const briskRules = ref([])
const getIntegralRule = async () => {
  const resData = await getBriskRuleApi()
  if (resData) {
    briskRules.value = resData.scene_list
  }
}

const curBriskData = computed(() => list.value[0] || {})

const goUploadGroupPic = async () => {
  const resData = await groupScreenshotDetailApi()
  if (resData && resData.rid === 0) {
    navigateTo('/brisk/briskUploadGroupPic')
  } else {
    navigateTo('/brisk/briskGroupPicCheckStatus')
  }
}

const isHasUploadGroup = ref(false)
const getIsHasUploadGroup = async () => {
  const resData = await getIsHasUploadGroupApi()
  isHasUploadGroup.value = Boolean(resData && resData.is_upload)
}
onMounted(async () => {
  await getList()
  getIntegralRule()
  getIsHasUploadGroup()
})
</script>
<style lang="less" scoped>
.page-container {
  font-size: 14px;
  padding: 16px 0px;
  // padding-top: 16px;
  // margin-top: 10px;
  overflow: auto;
  .active-value-des-tag {
    position: absolute;
    right: 0;
    top: 6px;
    padding: 4px 8px;
    // background: #ffffff;
    border-radius: 100px 0px 0px 100px;
    opacity: 0.6;
    z-index: 2;
    color: #999;
    font-size: 11px;
  }
  .active-value-bg {
    position: absolute;
    top: 0;
    left: 0;
  }
  .top-box {
    padding-left: 23px;
    padding-top: 7px;
    padding-bottom: 30px;
    overflow: hidden;
    position: relative;
    .finish-title {
      font-size: 16px;
      font-weight: 500;
    }
    .active-box {
      color: #999;
      font-size: 14px;
      margin-top: 5px;
    }
    .upload-group-pic-btn {
      height: 28px;
      width: 80px;
      margin-top: 20px;
      padding: 0 10px;
      border-radius: 16px;
      font-size: 12px;
    }
    .active-value-des-tag {
      background-color: #fff;
    }
    .big-gold-coin {
      position: absolute;
      top: -10px;
      right: 12px;
    }
  }
  .not-lev-top-box {
    position: relative;
    margin: 0 12px;
    background: linear-gradient(90deg, #ffced5 0%, #ff8d9c 100%);
    border-radius: 12px;
    height: 108px;
    .big-six-bg {
      position: absolute;
      z-index: 0;
    }
    .not-lev-cur-value-box {
      position: absolute;
      width: 100%;
      padding: 20px;
      display: flex;
      color: #fff;
      justify-content: space-between;
      align-items: center;
      .value {
        font-size: 36px;
        font-weight: 800;
      }
      .arrow {
        vertical-align: super;
      }
      .view-rank-btn {
        width: 72px;
        height: 28px;
        background: #fff7f8;
        border-radius: 16px;
        color: #ff97a5 !important;
        font-size: 12px;
        padding: 0;
      }
      .active-value-des-tag {
        background-color: #ffffff4d;
        color: #fff;
        top: 12px;
      }
      .view-rank-tag {
        position: absolute;
        top: 0;
        right: 0;
        width: 68px;
        height: 22px;
        line-height: 22px;
        background: #ffffff4d;
        border-radius: 0px 12px 0px 12px;
        font-size: 12px;
        text-align: center;
        // opacity: 0.3;
      }
      .rule-des-target {
        display: inline-block;
        width: 50px;
        // height: 16px;
        background: #ffffff4d;
        border-radius: 12px;
        color: #fff;
        padding: 2px 5px;
        font-size: 12px;
      }
    }
  }
  .content-box {
    border-radius: 8px;
    overflow: hidden;
    .cur-active-value-box {
      margin: 12px;
      background-color: #fff;
      padding: 16px;
      border-radius: 8px;
      position: relative;
      .cur-active-value-wrp {
        font-size: 16px;
        font-weight: 500;
        .cur-active-value {
          color: #ff97a5;
        }
        .total-active-value {
          color: #999;
        }
      }
      .view-rank-btn {
        position: absolute;
        width: 64px;
        height: 24px;
        border-radius: 16px;
        font-size: 12px;
        top: 16px;
        right: 16px;
        padding: 2px 0px;
      }
      .cur-active-pre-bar {
        position: relative;
        margin-top: 28px;
        padding-bottom: 35px;
        .complete-par {
          width: 100%;
          height: 6px;
          background: #f8fafc;
          border-radius: 3px;
        }
        .active-par {
          position: absolute;
          width: 30%;
          height: 6px;
          background: linear-gradient(90deg, #ffe0e4 0%, #ff97a5 100%);
          border-radius: 3px;
          left: 0;
          top: 0;
        }
        .point {
          text-align: center;
          position: absolute;
          color: #999999;
        }
        .reached-point {
          left: 28%;
          top: -15px;
        }
        .finish-point {
          right: 0;
          top: -12px;
        }
      }
    }
    .history-box-title {
      font-weight: 500;
      color: #222222;
      line-height: 22px;
      font-size: 16px;
      margin-left: 12px;
      margin-top: 20px;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 12px;
        background: #ff97a5;
        border-radius: 2px;
      }
    }
    .list-item-wrp {
      padding: 16px;
      margin: 12px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .list-item-content {
        .active-value-box {
          display: flex;
          align-items: center;
          .active-value {
            color: #222222;
            font-size: 16px;
            font-weight: 500;
            color: #222222;
            line-height: 22px;
            margin-right: 5px;
          }
          .view-rank {
            color: #ff97a5;
            line-height: 16px;
            font-size: 12px;
          }
        }
        .done-time {
          margin-top: 10px;
          font-size: 12px;
          color: #999999;
        }
      }
      .view-details {
        color: #999999;
        font-size: 12px;
      }
    }
  }
  .active-value-rule-box {
    font-size: 14px;
    padding: 16px;
    .active-value-rule-title {
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 15px;
    }
    // .active-value-get-title {
    //   margin-bottom: 10px;
    // }
    .active-value-get-type {
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      // margin-bottom: px;
      // }
      // .active-value-flex {
      //   display: flex;
      //   justify-content: space-between;
      //   margin-top: 10px;
      //   // margin-bottom: 10px;
      // }
    }
  }
  // background-image: url('/@/assets/img/integral_bg.png');
}
</style>
